import { createAsyncStateHook } from './utils'
import { getAvatars } from 'src/services/avatarServices'

export const useAvatars = createAsyncStateHook('avatars', getAvatars)
